export interface Realm {
  id: string;
  name: string;
  stage: string;
  desc: string;
  features: string[];
  cover: string;
}

export const realms: Realm[] = [
  {
    id: "r1",
    name: "炼气",
    stage: "第一境",
    desc: "引气入体，打通经脉，迈出修真的第一步。此境重在固本培元，是绝大多数宗门弟子的起点。",
    features: ["引气入体", "强身健体", "寿元略延"],
    cover: "https://readdy.ai/api/search-image?query=Serene%20green%20mountain%20stream%20among%20pines%20with%20soft%20mist%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20beginning%20realm%2C%20hand%20drawn%20brush%20strokes%2C%20fresh%20calm%20mood&width=600&height=600&seq=realm-lianqi&orientation=squarish",
  },
  {
    id: "r2",
    name: "筑基",
    stage: "第二境",
    desc: "以灵气铸就道基，灵气运用开始精细。招式具备个人风格，是宗门中坚力量的主力层级。",
    features: ["灵气外放", "御器而行", "道基成形"],
    cover: "https://readdy.ai/api/search-image?query=Steady%20stone%20foundation%20platform%20rising%20from%20a%20calm%20lake%20under%20warm%20light%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20foundation%20building%2C%20hand%20drawn%20brush%20strokes%2C%20solid%20grounded%20mood&width=600&height=600&seq=realm-zhuji&orientation=squarish",
  },
  {
    id: "r3",
    name: "金丹",
    stage: "第三境",
    desc: "凝结金丹，体内灵气自成循环，被视为踏入强者之列的分水岭，各方势力争相拉拢的对象。",
    features: ["灵气循环", "法则初悟", "一丹定成败"],
    cover: "https://readdy.ai/api/search-image?query=Glowing%20golden%20orb%20suspended%20in%20swirling%20warm%20energy%20above%20still%20water%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20golden%20core%20realm%2C%20radiant%20gold%20accents%2C%20hand%20drawn%20brush%20strokes%2C%20majestic%20glow&width=600&height=600&seq=realm-jindan&orientation=squarish",
  },
  {
    id: "r4",
    name: "元婴",
    stage: "第四境",
    desc: "元婴凝聚，神识大幅扩展，战斗开始触及法则层面，寿元与实力都发生质变。",
    features: ["神识外放", "元神出窍", "法则交锋"],
    cover: "https://readdy.ai/api/search-image?query=Small%20luminous%20spirit%20figure%20of%20light%20hovering%20within%20a%20soft%20warm%20aura%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20nascent%20soul%20realm%2C%20hand%20drawn%20brush%20strokes%2C%20ethereal%20radiant%20mood&width=600&height=600&seq=realm-yuanying&orientation=squarish",
  },
  {
    id: "r5",
    name: "化神",
    stage: "第五境",
    desc: "神与道合，举手投足间可牵动天地灵气，是镇守一方的顶尖存在。",
    features: ["神与道合", "牵动天地", "威压同境"],
    cover: "https://readdy.ai/api/search-image?query=Silhouette%20figure%20standing%20against%20swirling%20warm%20sky%20energy%2C%20hands%20wide%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20background%2C%20traditional%20xianxia%20spirit%20transformation%20realm%2C%20hand%20drawn%20brush%20strokes%2C%20overwhelming%20awe%20mood&width=600&height=600&seq=realm-huashen&orientation=squarish",
  },
  {
    id: "r6",
    name: "渡劫",
    stage: "第六境",
    desc: "历经天劫淬炼，稍有不慎便灰飞烟灭，是修真路上最凶险的一道关卡。",
    features: ["天劫淬炼", "心性考验", "险中求生"],
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20lightning%20bolt%20striking%20down%20toward%20a%20lone%20figure%20on%20a%20cliff%2C%20Chinese%20ink%20wash%20style%2C%20warm%20amber%20and%20crimson%20background%2C%20traditional%20xianxia%20tribulation%2C%20hand%20drawn%20brush%20strokes%2C%20intense%20tense%20mood&width=600&height=600&seq=realm-dujie&orientation=squarish",
  },
  {
    id: "r7",
    name: "大乘",
    stage: "第七境",
    desc: "道果圆满，堪破虚实，站在修真界的巅峰，距离飞升只差一步。",
    features: ["道果圆满", "堪破虚实", "巅峰之境"],
    cover: "https://readdy.ai/api/search-image?query=Perfect%20golden%20lotus%20blooming%20on%20a%20reflective%20pool%2C%20Chinese%20ink%20wash%20style%2C%20warm%20golden%20cream%20background%2C%20traditional%20xianxia%20great%20vehicle%20realm%2C%20hand%20drawn%20brush%20strokes%2C%20enlightened%20peaceful%20mood&width=600&height=600&seq=realm-dacheng&orientation=squarish",
  },
  {
    id: "r8",
    name: "飞升",
    stage: "巅峰",
    desc: "超脱尘世，通往更高天地的唯一道路，也是无数修士毕生追寻的终点。",
    features: ["超脱尘世", "飞升上界", "大道之终"],
    cover: "https://readdy.ai/api/search-image?query=Stairway%20of%20light%20ascending%20into%20golden%20clouds%20toward%20the%20heavens%2C%20Chinese%20ink%20wash%20style%2C%20warm%20cream%20and%20gold%20background%2C%20traditional%20xianxia%20ascension%20realm%2C%20hand%20drawn%20brush%20strokes%2C%20transcendent%20hopeful%20mood&width=600&height=600&seq=realm-feisheng&orientation=squarish",
  },
];